import React from 'react';

export const WhyChooseUs = () => {
  return (
    <div className="py-16 bg-[#1A1F2C]/50">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-3xl font-bold text-center text-white mb-12">
          Why Choose Tradeco?
        </h2>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm">
            <h3 className="text-xl font-semibold text-white">Fast-Track Debt Payoff</h3>
            <p className="text-gray-300">
              We help you reduce your debt faster than you thought possible, with a proven system that has already helped thousands of South Africans.
            </p>
          </div>
          <div className="space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm">
            <h3 className="text-xl font-semibold text-white">Protect What's Yours</h3>
            <p className="text-gray-300">
              Keep your home, car, and other assets safe while you work toward financial freedom. Our solution is designed to protect what matters most.
            </p>
          </div>
          <div className="space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm">
            <h3 className="text-xl font-semibold text-white">Expert Legal Support</h3>
            <p className="text-gray-300">
              Our trusted legal team handles all negotiations and ensures you're fully protected throughout the entire process.
            </p>
          </div>
          <div className="space-y-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm">
            <h3 className="text-xl font-semibold text-white">Peace of Mind</h3>
            <p className="text-gray-300">
              No more creditor harassment or sleepless nights. We'll take care of the hard work so you can focus on your future.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};